import React, { useState, useRef, useEffect } from "react";
import "./Layout.css";
import { ToastContainer } from "react-toastify";
import Header from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import { useLocation, Outlet } from "../../hooks/useRouter";
import { useSelector } from "react-redux";
import { useRbacInit } from "../../hooks/useRbacInit";
import useIsMobile from "../../hooks/useIsMobile";
import GlobalMiddleware from "../../services/GlobalMiddleware";

const Layout = () => {
  const location = useLocation();
  const isMobile = useIsMobile();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const sidebarRef = useRef(null);
  const isSidebarCollapsed = useSelector((state) => state.state?.sidebarCollapsed ?? true);
  const sidebarMode = "expand"; // "overlap" | "expand"

  // Initialize RBAC data on mount (handles page refresh)
  useRbacInit();

  // Close sidebar on route change on mobile
  useEffect(() => {
    if (isMobile) {
      setIsSidebarOpen(false);
    }
  }, [location.pathname, isMobile]);

  // Handle outside click for mobile
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isMobile &&
        isSidebarOpen &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        !event.target.closest(".menu-header-left") // Don't close when clicking toggle button
      ) {
        setIsSidebarOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isMobile, isSidebarOpen]);

  return (
    <>
      <ToastContainer
        closeButton={true}
        autoClose={1000}
        position="top-right"
      />
      <GlobalMiddleware>
        <div className="layout-container">
          {/* Header */}
          <div className={`header-section ${!isMobile && !isSidebarCollapsed && sidebarMode === "expand" ? "sidebar-expanded" : "sidebar-collapsed"}`}>
            <Header
              onToggleSidebar={() =>
                isMobile && setIsSidebarOpen((prev) => !prev)
              }
            />
          </div>

          {/* Sidebar */}
          <div
            ref={sidebarRef}
            className={`sidebar-section ${isMobile
              ? isSidebarOpen
                ? "open"
                : "closed"
              : "desktop"
              }`}
          >
            <Sidebar isSidebarOpen={isSidebarOpen} />
          </div>

          {/* Content — shifts right when sidebar is open on desktop and mode is expand */}
          <div className={`content-section ${!isMobile && !isSidebarCollapsed && sidebarMode === "expand" ? "sidebar-expanded" : "sidebar-collapsed"}`}>
            <Outlet />
          </div>
        </div>
      </GlobalMiddleware>
    </>
  );
};

export default Layout;